import axios from 'axios'
const token = window.sessionStorage.getItem('token')
const user = window.sessionStorage.getItem('user')
const baseURL = `${process.env.URL_API}`
const createClient = (options = { baseURL }) => axios.create(options)
const http = createClient()
http.interceptors.request.use(config => {
  if (token) {
    config.headers['Authorization'] = `JWT ${token}`
  }
  if (user) {
    config.headers['UserApp'] = user
  }
  return config
})
export default http



// WEBPACK FOOTER //
// ./src/http.js